module.exports = "/_next/static/images/3ec3195749c28682d698b7d916467372-mockup-transfer-fgts@0.5x.jpg.webp";